export default "__VITE_ASSET___ZVYGIt2__"